<script lang="ts">
	import Circle from './Circle.svelte';
	import Grid from './Grid.svelte';
	import { gsap } from 'gsap';

	let width = $state(200);
	let height = $state(200);

	let tilesX = 5;
	let tilesY = 5;

	const largeRadius = $derived(Math.min(width, height) * 0.3);
	const smallRadius = $derived(largeRadius * 0.65);
	const miniRadius = $derived(smallRadius * 0.35);
	const cutId = $derived(`eye-cut`);

	let pupilPos = $state({ x: width * 0.5, y: height * 0.5 });
	let blur = $state({ value: 4 });

	$effect(() => {
		const timeline = gsap.timeline({ repeat: -1 });

		timeline.set(pupilPos, {
			x: -width,
			y: height * 0.5
		});
		timeline.set(blur, {
			value: 4
		});
		timeline.to(pupilPos, {
			x: width * 0.5,
			y: height * 0.5,
			duration: 1,
			ease: 'expo.out'
		});
		timeline.to(blur, {
			value: 0,
			duration: 1,
			ease: 'expo.inOut'
		});
		timeline.to(pupilPos, {
			x: width,
			y: height * 0.5,
			duration: 1,
			ease: 'expo.in'
		});

		return () => {
			timeline.kill();
		};
	});
</script>

<svg
	bind:clientWidth={width}
	bind:clientHeight={height}
	class="container"
	viewBox="0 0 {width} {height}"
	color-interpolation-filters="sRGB"
>
	<Grid {tilesX} {tilesY} {width} {height}></Grid>

	<clipPath id={cutId}>
		<rect
			x={width * 0.5 - smallRadius - 2}
			y={height * 0.5 - smallRadius - 2}
			width={smallRadius * 2 + 4}
			height={smallRadius * 2 + 4}
		></rect>
	</clipPath>

	<Circle x={width * 0.5} y={height * 0.5} {height} {width} r={largeRadius} blur={12}></Circle>
	<Circle x={width * 0.5} y={height * 0.5} {height} {width} r={smallRadius} fill="#F1EFEA"></Circle>
	<Circle
		x={pupilPos.x}
		y={pupilPos.y}
		{height}
		{width}
		r={miniRadius}
		blur={blur.value}
		clip-path="url(#{cutId})"
	></Circle>
</svg>

<style lang="scss">
	.container {
		width: 100%;
		height: 100%;
	}

	svg {
		will-change: transform, filter, blur;
	}
</style>
